// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Wmij","footer":"ModalError_footer__PtFbf"};